import api from './apiClient';

const goalApi = {
  // Accept optional query params for server-side filtering
  getGoals: (params) => api.get('/performance/goals', { params }),
  getGoalStats: (params) => api.get('/performance/goals/stats', { params }),
  getGoalById: (id) => api.get(`/performance/goals/${id}`),
  createGoal: (data) => api.post('/performance/goals', data),
  updateGoal: (id, data) => api.put(`/performance/goals/${id}`, data),
  deleteGoal: (id) => api.delete(`/performance/goals/${id}`),
  getGoalsByEmployee: (employeeId) => api.get(`/performance/goals/employee/${employeeId}`),
  getGoalsByCycle: (cycleId) => api.get(`/performance/goals/cycle/${cycleId}`),
  updateGoalProgress: (id, data) => api.patch(`/performance/goals/${id}/progress`, data),
  approveGoal: (id) => api.patch(`/performance/goals/${id}/approve`),
  rejectGoal: (id, reason) => api.patch(`/performance/goals/${id}/reject`, { reason }),
  getEmployeesWithGoals: () => api.get('/performance/employees/with-goals')
};

export { goalApi };

